module.exports = __webpack_public_path__ + "img/pescao_con_camarones.4bf0b7d0.jpg";